import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ModalController } from '@ionic/angular';

import { DocumentReference, DropdownItem, NameValue } from '../../core/models';
import {
  ActivityFormatService, AgeGroupService, ArrayService, AuthService, ChurchService, 
  DatabaseService, DocumentService, SportTeamService, FestivalUserService, UserService
} from 'src/core/services';
import { PageClass } from 'src/core/classes/page';
import { TextService } from 'src/core/services/text-service';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.less', '../../core/styles/common.less']
})

export class EditUserComponent extends PageClass implements OnInit {

  userId: string;
  user: any = {};

  @Input() festivalUser: any;

  dropdownItemList: DropdownItem[];
  selectedItems: DropdownItem[] = [];

  activityList: NameValue[] = [];
  ageGroups: DocumentReference[];
  priestList: DocumentReference[];
  roleList: string[] = [];
  sportList: NameValue[] = [];
  years: DocumentReference[];

  isLoading = true;

  @ViewChild('userForm', null) userForm: NgForm;

  constructor(
    protected activityFormatService: ActivityFormatService,
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    private documentService: DocumentService,
    protected sportTeamService: SportTeamService,
    protected userService: UserService,
    protected festivalUserService: FestivalUserService,
    private modalController: ModalController,
    private textService: TextService
  ) {
    super(ageGroupService, arrayService, authService, churchService, databaseService, festivalUserService);
  }

  protected loadData = async () => {
    if (!this.currentUser.isAdmin || !this.currentUser.isActive || this.currentUser.isDeleted) {
      this.dismissModal();
    }
    // Get User
    this.user = await this.documentService.getDocumentById('users', this.festivalUser.user.reference.id);
    this.user.id = this.festivalUser.user.reference.id;
    
    this.activityList = this.activityFormatService.getActivityList();
    this.sportList = this.sportTeamService.getSportList();
    
    this.getLists();
  }

  private async getLists() {
    this.roleList = this.userService.GetUserRoleList();
    (await this.ageGroupService.getAgeGroups()).subscribe( ageGroups => {
      this.ageGroups = [];
      ageGroups.map(a => this.ageGroups.push({
        displayName: a.displayName, 
        reference: this.databaseService.doc(`ageGroups/${a.id}`).ref
      }));

      var groups = [];
      for (const group of this.festivalUser.ageGroupList) {
        groups.push(this.ageGroups.filter(a => a.reference.id === group.reference.id)[0]);
      }

      this.festivalUser.ageGroupList = groups;
    });

    if (this.festivalUser.church) {
      this.user.church = this.churchList.find(c => c.reference.id === this.festivalUser.church.reference.id);
    }

      this.isLoading = false;
  }

  public async editUser() {

    if (this.userForm.invalid) {
      return;
    }

    this.user = {
      ...this.user,
      firstName: this.textService.toPascalCase(this.user.firstName),
      lastName: this.textService.toPascalCase(this.user.lastName),
      email: this.textService.toLowerCase(this.user.email)
    };
    
    this.festivalUser = {
      ...this.festivalUser,
      church: this.user.church,    
      email: this.user.email,
      role: this.user.role,
      user: {
        reference: this.databaseService.doc(`users/${this.user.id}`).ref,
        displayName: `${this.user.firstName} ${this.user.lastName}`
      }
    };

    this.documentService.updateDocument('users', this.user);
    this.documentService.updateDocument(this.festivalUserService.collection, this.festivalUser);

    this.dismissModal();
  }

  dismissModal() {
    this.modalController.dismiss();
  }
}
